import { render, staticRenderFns } from "./comConfigTable.vue?vue&type=template&id=1dc68308&scoped=true&"
import script from "./comConfigTable.js?vue&type=script&lang=js&"
export * from "./comConfigTable.js?vue&type=script&lang=js&"
import style0 from "./comConfigTable.scss?vue&type=style&index=0&id=1dc68308&lang=scss&scoped=true&"
import style1 from "./comConfigTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc68308",
  null
  
)

export default component.exports